"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _path = _interopRequireDefault(require("../../../helpers/path"));
var _reactInlinesvg = _interopRequireDefault(require("react-inlinesvg"));
var _config = _interopRequireDefault(require("../../../config"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
require("./APLogo.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var APLogo = function APLogo(props) {
  var customClass = props.customClass,
    linkTo = props.linkTo,
    onClick = props.onClick;
  var bemClasses = (0, _cssClassesHelper.getBEMClasses)('ap-logo', customClass);
  var renderSiteLogo = function renderSiteLogo() {
    if (_config["default"].global.siteLogo.match(/.svg$/) && !_config["default"].Logo.DoNotInLineSVG) {
      return /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
        alt: "Site logo",
        src: (0, _path["default"])("/local/logos/".concat(_config["default"].global.siteLogo)),
        className: bemClasses('img')
      });
    } else {
      return /*#__PURE__*/_react["default"].createElement("img", {
        alt: "Site logo",
        src: (0, _path["default"])("/local/logos/".concat(_config["default"].global.siteLogo)),
        className: bemClasses('img')
      });
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, linkTo ? /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    className: bemClasses('link'),
    to: (0, _path["default"])(linkTo),
    onClick: onClick
  }, renderSiteLogo()) : renderSiteLogo());
};
APLogo.defaultProps = {
  customClass: '',
  linkTo: ''
};
APLogo.propTypes = {
  customClass: _propTypes["default"].string,
  linkTo: _propTypes["default"].string,
  onClick: _propTypes["default"].func
};
var _default = exports["default"] = APLogo;